/** The element id a placed static node carries, so a click resolves to a part without an index. */
export const STATIC_ELEMENT_ID_ATTR = 'data-element-id';

/**
 * Where a rendered element's own id lives, in the DOM.
 *
 * A heading is the one element rendered with a plain `id` and no `data-id`, so a lookup for `data-id`
 * alone walks past it and finds whatever wraps it - inside a landscape section, that is the section.
 * `OWN_ID_PATTERN` indexes the same three for the model, plus `data-field-id` for the field de-duplication.
 */
export const ELEMENT_ID_ATTRS = ['data-id', 'data-comment-id', 'id'] as const;

export const ELEMENT_ID_SELECTOR = ELEMENT_ID_ATTRS.map((attr) => `[${attr}]`).join(',');

export const ownIdOf = (element: Element | null): string | null =>
  ELEMENT_ID_ATTRS.reduce<string | null>((found, attr) => found ?? element?.getAttribute(attr) ?? null, null);

/** Every placed element's position in the document, including the ones with no id of their own. */
export const STATIC_ELEMENT_INDEX_ATTR = 'data-element-index';

/**
 * Which slice of its section a drawn `<section>` is: the live part cuts one into up to three pieces,
 * and only the outer ends draw the page's border, margin and height.
 */
export const SECTION_PIECE_ATTR = 'data-section-piece';
export type TSectionPiece = 'only' | 'first' | 'middle' | 'last';

/** Marks a static half, so code can tell "this is not the editor" from "this is not the document". */
export const LARGE_DOCUMENT_STATIC_CLASS = 'large-document-static';

/** Applied to the editor root while it rebuilds; the styling lives in `_content-large-document.scss`. */
export const BUILDING_CLASS = 'large-document-building';
